import { Component } from '@angular/core';

@Component({
    selector: 'gbc-modal-content',
    templateUrl: './modal-content.component.html',
    styleUrls: ['./modal-content.component.scss'],
})
export class ModalContentComponent {
  constructor() {}
}
